// Module
var code = "<!DOCTYPE html>\n<select class=\"iw-time-selector__value form-control\"></select>";
// Exports
export default code;